import React, { useState, useRef, useEffect } from 'react';
import { DropdownContent, DropdownWrapper, Trigger } from './styles';
import { rootStore } from '../../mobx/rootStore';
import { useMobileDevice } from '../../global/useMobile';

interface DropdownProps {
  trigger?: (isActive: boolean) => React.ReactNode;
  content: React.ReactNode;
  placement?: 'bottomLeft' | 'bottomRight';
  isTaskFilterOpen?: boolean;
  isMinWidth?: number;
  isModal?: boolean;
}

const TaskFilterDropdown: React.FC<DropdownProps> = ({
  trigger,
  content,
  placement = 'bottomLeft',
  isTaskFilterOpen = false,
  isMinWidth = 247,
  isModal = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const isMobile = useMobileDevice();

  // Toggle dropdown
  const toggleDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const targetElement = e.target as HTMLElement;
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(targetElement) &&
        !targetElement.closest('.reference-item')
      ) {
        setIsOpen(false);
        rootStore.taskStore?.setIsTaskFilterOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // renders when modal & mobile is true
  if (isMobile && isModal)
    return (
      <DropdownContent isModal={isModal} isMinWidth={isMinWidth}>
        {content}
      </DropdownContent>
    );

  return (
    <>
      <DropdownWrapper ref={dropdownRef}>
        {/* Applies the active class to the Project Details filter icon when the dropdown is open */}
        <Trigger role='button' onClick={toggleDropdown} className={isOpen ? 'activeClassName' : ''}>
          {trigger && trigger(isOpen || isTaskFilterOpen)}
        </Trigger>
        {(isOpen || isTaskFilterOpen) && <DropdownContent isMinWidth={isMinWidth}>{content}</DropdownContent>}
      </DropdownWrapper>
    </>
  );
};

export default TaskFilterDropdown;
